export const theme = {
    paragraph: 'raw-html-paragraph',

    heading: {
        h1: 'raw-html-heading raw-html-heading-h1',
        h2: 'raw-html-heading raw-html-heading-h2',
        h3: 'raw-html-heading raw-html-heading-h3',
        h4: 'raw-html-heading raw-html-heading-h4',
        h5: 'raw-html-heading raw-html-heading-h5',
    },

    list: {
        listitem: 'raw-html-listitem',
        nested: {
            listitem: 'raw-html-nested-listitem',
        },
        ol: 'raw-html-list-ol',
        ul: 'raw-html-list-ul',
    },

    link: 'raw-html-link',
    ltr: 'ltr',
    rtl: 'rtl',

    table: 'raw-html-table',
    tableAddColumns: 'raw-html-table-add-columns',
    tableAddRows: 'raw-html-table-add-rows',
    tableAlignment: {
        center: 'raw-html-table-alignment-center',
        right: 'raw-html-table-alignment-right',
    },
    tableCell: 'raw-html-table-cell',
    tableCellActionButton: 'raw-html-table-cell-action-button',
    tableCellActionButtonContainer: 'raw-html-table-cell-action-button-container',
    tableCellHeader: 'raw-html-table-cell-header',
    tableCellResizer: 'raw-html-table-cell-resizer',
    tableCellSelected: 'raw-html-table-cell-selected',
    tableFrozenColumn: 'raw-html-table-frozen-column',
    tableFrozenRow: 'raw-html-table-frozen-row',
    tableRowStriping: 'raw-html-table-row-striping',
    tableScrollableWrapper: 'raw-html-table-scrollable-wrapper',
    tableSelected: 'raw-html-table-selected',
    tableSelection: 'raw-html-table-selection',
};